import React from 'react';
import { BuyerInfoModalProps } from './types';

const DynamicBuyerInfoModal = React.lazy(
  () => import(/* webpackChunkName: "FavouritesUiDynamicBuyerInfoModal" */ './DynamicBuyerInfoModal'),
);

const BuyerInfoModal = ({ onClose, onTrack }: BuyerInfoModalProps) => {
  return (
    <React.Suspense fallback={null}>
      <DynamicBuyerInfoModal onClose={onClose} onTrack={onTrack} />
    </React.Suspense>
  );
};

export default BuyerInfoModal;
